import { observable, action } from 'mobx'
import { browserHistory } from 'react-router'
import { History } from 'history'

interface IPagination {
  offset: number
  limit: number
}

export class PaginationUtil {
  @observable
  history: any

  @observable
  paginationFilter: IPagination = {
    offset: 0,
    limit: 25,
  }

  constructor(history: History, setDefaultHistory: boolean) {
    this.history = history
    const initialQuery = history.getCurrentLocation().query

    // If url params exist, fill them in
    if (initialQuery.offset) {
      this.paginationFilter.offset = parseInt(initialQuery.offset)
    }
    if (initialQuery.limit) {
      this.paginationFilter.limit = parseInt(initialQuery.limit)
    }

    if (setDefaultHistory) {
      this.apply()
    }
  }

  apply(queries: object = {}) {
    this.history.replace({
      pathname: this.history.getCurrentLocation().pathname,
      query: {
        ...queries,
        ...this.paginationFilter,
      },
    })
  }

  @action
  setLimit(limit: number) {
    this.paginationFilter.offset = 0
    this.paginationFilter.limit = limit
    this.apply()
  }

  @action
  setOffset(offset: number) {
    this.paginationFilter.offset = offset
    this.apply()
  }
}
